import { jsx as _jsx } from "react/jsx-runtime";
var Play4 = function Play4(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size * 1.13,
    viewBox: "0 0 30 34",
    children: /*#__PURE__*/_jsx("path", {
      fill: !ignoreColor ? color : undefined,
      stroke: "#DFE1E6",
      strokeWidth: 2.5,
      d: "M2 3.585v26.83a1.5 1.5 0 0 0 2.244 1.303l23.477-13.416a1.5 1.5 0 0 0 0-2.604L4.244 2.282A1.5 1.5 0 0 0 2 3.585z"
    })
  });
};
export default Play4;